import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginServiceBase } from '../login.service.base';
import { LoginService } from '../login.service';
import { OrganizationsService } from 'src/app/Services/organizations.service';
@Component({
    selector: 'app-orgswitch',
    templateUrl: './orgswitch.component.html',
    styleUrls: ['./orgswitch.component.scss'],
    standalone: false
})
export class OrgswitchComponent implements OnInit {

  constructor(private router: Router, private loginService: LoginServiceBase, private parentRoute: ActivatedRoute, public OrganizationsService: OrganizationsService) { }

  orgName: string = '';

  ngOnInit(): void {
    let orgId = this.parentRoute.snapshot.params['id'];
    this.OrganizationsService.GetOrganization(orgId).then((org : any) => {
      this.orgName = org.Name;
    });
    this.loginService.DoOrganizationSwitch(orgId);
  }

}
